import api from './api';

export const jobMonitorService = {
  // Fetch jobs list with filters and priority summary
  getJobs: async (params = {}) => {
    const response = await api.get('/job-monitor', { params });
    return response.data;
  },

  // Fetch single job by ID
  getJob: async (id) => {
    const response = await api.get(`/job-monitor/${id}`);
    return response.data;
  },

  // Create new job entry
  createJob: async (data) => {
    const response = await api.post('/job-monitor', data);
    return response.data;
  },

  // Update existing job entry
  updateJob: async (id, data) => {
    const response = await api.put(`/job-monitor/${id}`, data);
    return response.data;
  },

  // Delete job entry
  deleteJob: async (id) => {
    const response = await api.delete(`/job-monitor/${id}`);
    return response.data;
  },
};
